var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrganisationWithLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-organisation-with-link_svg__clip0_3159_37464)",
    stroke: "#2F19B3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2 10.52a1.376 1.376 0 102.753 0 1.376 1.376 0 00-2.753 0zM17.825 13.614a2.842 2.842 0 00-4.49 0M3.047 10.52a1.376 1.376 0 102.753 0 1.376 1.376 0 00-2.753 0zM2.175 13.614a2.842 2.842 0 014.488-.007M13.51 14.7a3.51 3.51 0 10-7.02 0M7.89 8.157a2.074 2.074 0 104.148 0 2.074 2.074 0 00-4.148 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.188 10a8.812 8.812 0 1017.624 0 8.812 8.812 0 00-17.625 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-organisation-with-link_svg__clip0_3159_37464"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
export default SvgIconOrganisationWithLink;